<template>
  <div class="page">
    <groups-query-list
      title="Resultados das Consultas"
      subtitle="Nesta tela você cria e verifica resultados de consultas."
      :create-route="{ name: 'Compliance-Legal-Person-Create' }"
    />
  </div>
</template>

<script>
import GroupsQueryList from '@/compliance/components/GroupsQueryList.vue';

export default {
  name: 'Result',

  components: {
    GroupsQueryList,
  },
};
</script>

<style scoped>

</style>
